import PanelPartDetails from './PanelPartDetails'

export default PanelPartDetails
